import { SignInUrlBuilder } from '@tableau/shared-urls/lib/src/SignInUrlBuilder';
import React from 'react';
import _ = require('underscore');

import { SignInLogo } from '../../../app/spaces/Login/SignInLogo';
import { Messages } from '../../../codegen/Localize';
import { ISiteNameSansId } from '../../../ts/ServerApi/types/ISiteNameSansId';
import { SiteSwitchService } from '../../../ts/siteManagement/services/SiteSwitchService';
import { LoginSitePicker } from './LoginSitePicker';

export interface LoginSitePickerComponentProps {
  sitePickerQueryParams: SignInUrlBuilder.QueryParams;
}

const selectSite = (siteName: ISiteNameSansId, externalRedirect: string) => {
  if (siteName) {
    const siteUrl: string = siteName.urlName;
    if (externalRedirect) {
      SiteSwitchService.switchIfNeededAndRedirectToAuth(siteUrl, externalRedirect);
    } else {
      SiteSwitchService.switchIfNeededAndRedirectToStartPage(siteUrl);
    }
  }
};

export function LoginSitePickerComponent(props: LoginSitePickerComponentProps): JSX.Element {

  function renderSitePicker(props: LoginSitePickerComponentProps): JSX.Element {
    const pickerProps = {
      handleSelectSiteOption: (siteName: ISiteNameSansId) => {
        selectSite(siteName, props.sitePickerQueryParams.externalRedirect);
      }
    };
    return (
      <LoginSitePicker {...pickerProps} />
    );
  }

  return (
    <div className="tb-login tb-login-site-picker-container">
      <SignInLogo />
      <div className="tb-login-title" id="textbox-sitepicker-label" data-tb-test-id='login-site-picker-title'>
        {Messages.selectASite()}
      </div>
      <div className="tb-login-site-picker">
        {renderSitePicker(props)}
      </div>
    </div>
  );
}
